import {
  displayErrorModal,
  addToAsyncSet,
  removeFromAsyncSet,
} from 'actions/application'
import { isObject, isArray, isString, isFunction } from 'utils/types'

const isPromise = (val) => val && isFunction(val.then)

const createDisplayErrorModal = (error) => {
  // ramda type == object fails on Error
  if (
    error.constructor &&
    error.constructor.name &&
    error.constructor.name.endsWith('Error')
  ) {
    return displayErrorModal(error.constructor.name, [error.message])
  }
  if (isObject(error)) {
    // is this a use case we should keep?
    return displayErrorModal(error.code, [error.message])
  }
  const errorMessages = isArray(error)
    ? error
    : isString(error)
    ? [error]
    : [JSON.stringify(error)]
  return displayErrorModal('Internal Error', errorMessages)
}

export default ({ dispatch }) => (next) => async (action) => {
  if (!action.payload || !isPromise(action.payload) || action.errorCode)
    return next(action)

  // do our special promise work
  const { type, payload, uniqueErrorAction, ...restAxn } = action
  dispatch(addToAsyncSet(type))

  try {
    const { result, data } = await payload // the API alreays returns a response object with a result and a data property

    if (result.code !== 'OK') {
      console.log('promiseHandler try result is ', result)
      if (uniqueErrorAction) {
        return dispatch(uniqueErrorAction(result))
      }

      throw result
    }

    next({
      type,
      payload: data,
      ...restAxn,
    })

    return dispatch(removeFromAsyncSet(type))
  } catch (err) {
    dispatch(createDisplayErrorModal(err))
  }
}
